import { PureComponent, PropsWithChildren } from "react";

export default class VehicleBlockComponentsShell extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-vehicle-block__components-block">
        {this.props.children}
      </div>
    );
  }
}
